module.exports = __webpack_public_path__ + "img/news-image1.e752d07d.png";